/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Web_BadgeInputs */

const tr_landing_web_badge = /** @type {(inputs: Landing_Web_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Çok yakında`)
};

const en_landing_web_badge = /** @type {(inputs: Landing_Web_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coming very soon`)
};

const de_landing_web_badge = /** @type {(inputs: Landing_Web_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sehr bald`)
};

const ru_landing_web_badge = /** @type {(inputs: Landing_Web_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Уже совсем скоро`)
};

/**
* | output |
* | --- |
* | "Coming very soon" |
*
* @param {Landing_Web_BadgeInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_web_badge = /** @type {((inputs?: Landing_Web_BadgeInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Web_BadgeInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_web_badge(inputs)
	if (locale === "de") return de_landing_web_badge(inputs)
	if (locale === "ru") return ru_landing_web_badge(inputs)
	return tr_landing_web_badge(inputs)
});